export default "__VITE_PUBLIC_ASSET__238f6f30__"